<template>
  <div>
    <b-container fluid>
      <!-- User Interface controls -->
      <b-row>
        <b-col
          sm="4"
          md="4"
          class="my-1"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        striped
        hover
        :items="items"
        :fields="fields"
        :tbody-tr-class="rowClass"
        :current-page="currentPage"
        :per-page="perPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :busy="loading"
      >
        <template v-slot:table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>

        <template v-slot:cell(package)="row">
          <div v-if="row.item.memberpackage!=null">
            {{ row.item.memberpackage.package.type }} {{ row.item.memberpackage.package.duration }}
            <span v-if="row.item.subscription">[{{ row.item.subscription.paid }}/{{
              row.item.subscription.total
            }}]</span>
          </div>
          <div v-if="row.item.productpurchase!=null">
            {{ row.item.productpurchase.product.name }}
          </div>
        </template>
        <template v-slot:cell(sale_date)="data">
          {{ getFormatDateDisplay(data.value) }}
        </template>
        <template v-slot:cell(price_total)="row">
          <span v-if="row.item.status != 'VOID'">{{
            row.item.price_total
          }}</span>
          <span
            v-else
            class="paidtxt"
          >{{ row.item.price_total }}</span>
        </template>
        <template v-slot:cell(actions)="row">
          <div v-if="isAuthLv2 == true">
            <b-button
              size="sm"
              @click.prevent="unlocksubModal(row.item.id)"
              class="mr-1"
              variant="secondary"
              v-if="row.item.status != 'VOID'"
            >
              <i class="fas fa-trash-alt"></i>
            </b-button>
            <div
              v-else
              class="refundtxt"
            >
              <div class="block">VOID</div>
              <div class="block">
                <b-button
                  size="sm"
                  @click.prevent="confirmPermanentDelete(row.item.id)"
                  class="mr-2 permadel"
                  variant="secondary"
                >
                  <i class="fas fa-skull-crossbones"></i>
                </b-button>
              </div>
            </div>
          </div>
        </template>
      </b-table>
    </b-container>
    <div>
      <b-modal
        id="cf-modal"
        title="Comfirm"
        @ok="handleOk"
      >
        <p class="my-4">Confirm Void Payment?</p>
        <textarea
          name="voidtxtarea"
          id="voidtxtarea"
          class="voidtxtarea"
          rows="2"
          v-model="voidreason"
        ></textarea>
      </b-modal>
      <b-modal
        id="cf-modal-2"
        title="Comfirm"
        @ok="handleOk2"
      >
        <p class="my-4">BEWARE:: Permanently Remove Payment?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { isAuthLv1, isAuthLv2 } from "./../js/utils/global.js";
import {
  packageTypeFull,
  packageDurationFull,
  getPackageFull
} from "./../js/utils/datamanip.js";
import { formatDateDisplay } from "./../js/utils/date.js";
export default {
  props: { memberid: Number },
  data() {
    return {
      loading: false,
      currentSubId: null,
      voidreason: null,
      fields: [
        /*{
          key: "id",
          label: "ID"
        },*/

        {
          key: "ref_number",
          label: "Ref #"
        },
        {
          key: "memberpackage_id",
          label: "MP ID"
        },
        {
          key: "sale_date",
          label: "Purchase Date"
        },
        {
          key: "payment_type",
          label: "Payment"
        },
        {
          key: "package",
          label: "Package"
        },
        {
          key: "price_unit",
          label: "Price"
        },
        {
          key: "qty",
          label: "Qty"
        },
        {
          key: "discount",
          label: "Discount"
        },
        {
          key: "tax",
          label: "Tax"
        },
        {
          key: "price_total",
          label: "Paid"
        },

        {
          key: "actions",
          label: "Void"
        }
      ],
      items: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc"
    };
  },
  mounted() {
    this.getPurchase();
  },
  computed: {
    isAuthLv2,
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.status === "VOID") {
        return "table-danger";
      } else if (item.price_total == 0) {
        return "table-primary";
      }
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.voidSale();
    },
    handleOk2(bvModalEvt) {
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.permanentDelete();
    },

    unlocksubModal(id) {
      this.currentSubId = id;
      this.$bvModal.show("cf-modal");
    },
    confirmPermanentDelete(id) {
      this.currentSubId = id;
      this.$bvModal.show("cf-modal-2");
    },
    async voidSale() {
      this.loading = true;
      await axios
        .post("/api/purchases/void", {
          id: this.currentSubId,
          note: this.voidreason
        })
        .then(response => {
          //console.log("len " + response.data.data.length);
          //console.log(response.data);
          //console.log(this.packageArr);
          this.getPurchase();
        })
        .catch(function(error) {
          //console.log(error.response.data.errors);
          //if(error.response.data.errors.message =)
        })
        .finally(() => {
          this.$bvModal.hide("cf-modal");
          this.loading = false;
        });
    },
    async permanentDelete() {
      this.loading = true;
      await axios
        .post("/api/purchases/remove", {
          id: this.currentSubId
        })
        .then(response => {
          //console.log("len " + response.data.data.length);
          //console.log(response.data);
          //console.log(this.packageArr);
          this.getPurchase();
        })
        .catch(function(error) {
          //console.log(error.response.data.errors);
          //if(error.response.data.errors.message =)
        })
        .finally(() => {
          this.$bvModal.hide("cf-modal-2");
          this.loading = false;
        });
    },
    async getPurchase() {
      this.loading = true;
      await axios
        .get("/api/members/purchase/" + this.memberid)
        .then(response => {
          //console.log(response.data);
          this.items = response.data;
          this.totalRows = this.items.length;
          //console.log(response.data.data);
          this.totalRows = this.items.length;
          this.loading = false;
        });
    },
    getLocalPackageFull(key) {
      return getPackageFull(key);
    },
    getFormatDateDisplay(date) {
      return formatDateDisplay(date);
    }
  }
};
</script>
<style scoped>
.paidtxt {
  /*color: lightsteelblue;*/
  text-decoration: line-through;
}
.refundtxt {
  color: #f00;
  font-weight: bold;
}
.permadel {
  background-color: purple;
}
.voidtxtarea {
  width: 100%;
}
/*
.table-danger,
.table-danger > th,
.table-danger > td {
  color: lightsteelblue !important;
}*/
</style>
